import { objectToSelectOptions } from '@monetize/utils/core';

export type SettingCardType =
  | 'Salesforce'
  | 'HubSpot'
  | 'Attio'
  | 'QuickBooks'
  | 'NetSuite'
  | 'Slack'
  | 'Xero'
  | 'Rillet'
  | 'Docusign'
  | 'Adobe Acrobat Sign';

export type SettingCardViewAction =
  | 'RE_AUTHENTICATE'
  | 'RESYNC-CATALOG'
  | 'DOCS-LINK'
  | 'VERIFY'
  | 'DELETE'
  | 'DISABLE'
  | 'ENABLE';

export const SETTING_INVOICE_DELAY_DISPLAY_FUTURE: {
  [key in number]: string;
} = {
  0: 'Keep as scheduled',
  1: '1 day after scheduled',
  2: '2 days after scheduled',
};

// https://monetizenow.atlassian.net/browse/BP-8621
export const SETTING_INVOICE_DELAY_DISPLAY: {
  [key in number]: string;
} = {
  [-30]: '30 days earlier',
  [-15]: '15 days earlier',
  [-14]: '14 days earlier',
  [-10]: '10 days earlier',
  [-7]: '7 days earlier',
  [-5]: '5 days earlier',
  [-3]: '3 days earlier',
  ...SETTING_INVOICE_DELAY_DISPLAY_FUTURE,
};

export const SETTING_INVOICE_DELAY_OPTIONS_PAST_AND_FUTURE =
  objectToSelectOptions(SETTING_INVOICE_DELAY_DISPLAY).sort(
    (a, b) => (a.value as unknown as number) - (b.value as unknown as number),
  );

export const SETTING_INVOICE_DELAY_OPTIONS_IN_FUTURE = objectToSelectOptions(
  SETTING_INVOICE_DELAY_DISPLAY_FUTURE,
);
